module.exports = __webpack_public_path__ + "img/map_Z3.4.B.04.d9544d01.svg";